import React, { useState } from "react";
import Modal from "react-modal";
import upload from "../../../assets/img/common/upload.svg";
import UploadFileCircularBar from "../ProgressBar/UploadFileCircularBar";

const ImageUploadingModal = ({
    selectedFiles,
    showUploadImageModal,
    uploadProgress,
}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const handleToggleCollapse = () => {
        setIsCollapsed((prevState) => !prevState);
    };

    // Helper function to truncate text
    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };


    return (
        <Modal
            isOpen={showUploadImageModal}
            ariaHideApp={false}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <div
                className={`modal-header-div d-flex justify-content-between align-items-center ${isCollapsed ? "" : "show-border-btn"
                    }`}
            >
                <div className="d-flex align-items-center">
                    <img src={upload} className="uploading-img" alt="Uploading Icon" />
                    <p className="modal-title ml-2">
                        Uploading {selectedFiles.length} Images
                    </p>
                </div>
                <i
                    className={`fas ${isCollapsed ? "fa-chevron-up" : "fa-chevron-down"
                        } toggleIcon`}
                    onClick={handleToggleCollapse}
                ></i>
            </div>

            {!isCollapsed && (
                <div className="progress-section">
                    {selectedFiles.map((file) => (
                        <UploadFileCircularBar
                            key={file.file.name}
                            text={truncateText(file.file.name, 20)}
                            uploadProgress={uploadProgress?.[file.file.name] || 0}
                            imgStyle={{ width: "25px", height: "25px" }}
                        />
                    ))}
                </div>
            )}

            <style jsx>{`
                /* Overlay styles */
                .custom-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: transparent !important;
                    pointer-events: none; /* Prevent overlay from capturing clicks */
                }

                /* Modal content styles */
                .custom-modal-content {
                    position: fixed !important;
                    bottom: 0px !important; /* Bottom positioning */
                    right: 20px !important; /* Right positioning */
                    width: 280px; /* Fixed width */
                    max-height: ${isCollapsed ? "60px" : "400px"}; /* Toggle height */
                    border: 1px solid #ccc;
                    border-radius: 8px 8px 0 0;
                    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
                    background-color: #fff;
                    padding: 10px;
                    overflow: ${isCollapsed ? "hidden" : "auto"};
                    z-index: 1000;
                    pointer-events: auto; /* Make modal interactive */
                }

                .modal-header-div {
                    background-color: #fff;
                    z-index: 10;
                    padding: 10px 5px;
                    border-bottom: 1px solid #dee2e6;
                }

                .modal-title {
                    font-family: Hind;
                    font-weight: 500;
                    font-size: 16px;
                    color: #572148;
                }

                .toggleIcon {
                    font-size: 1.2rem;
                    color: black;
                    opacity: 0.5;
                    cursor: pointer;
                }

                .toggleIcon:hover {
                    opacity: 0.8;
                }

                .uploading-img {
                    width: 25px;
                    height: 25px;
                }

                .progress-section {
                    padding-top: 10px;
                }
      `}</style>
        </Modal>
    );
};

export default ImageUploadingModal;
